import { defineEnv } from '../utils/app/defineEnv';

export const env = {
  RUN_MOCKS: defineEnv('REACT_APP_RUN_MOCKS', false),
  IS_DEVELOPMENT: defineEnv('NODE_ENV') === 'development',
  IS_TENANT_DEVELOPMENT: defineEnv('REACT_APP_TENANT_ENV') === 'development',
  BASE_URL: defineEnv('REACT_APP_BASE_URL'),
  GAMEFICATION_URL: defineEnv('REACT_APP_GAMEFICATION_URL'),
  AUTH_ENCRYPT_KEY: defineEnv('REACT_APP_AUTH_ENCRYPT_KEY', false) as string,
  CHECKOUT: defineEnv('REACT_APP_CHECKOUT_URL'),
  ASSETS: defineEnv('REACT_APP_ASSETS'),
  PROGRAM_ASSETS: defineEnv('REACT_APP_PROGRAM_ASSETS'),
  FILE_API: defineEnv('REACT_APP_FILE_API'),
  URL_SITE: defineEnv('REACT_APP_URL_SITE'),
  TENANT_API_URL: defineEnv('REACT_APP_TENANT_API_URL'),
  TENANT_ID: defineEnv('REACT_APP_TENANT_ID'),
  RECAPTCHA_V2SITE_KEY_PAY: defineEnv('REACT_APP_RECAPTCHA_V2SITE_KEY_PAY'),
};
